
export default function CategoryDetailsPage() {
  return (
    <div>CategoryDetailsPage</div>
  )
}
